import React from "react";
import themePropTypes from "../theme-prop-types";

const Bullet = ({ title, text, color }) => {
  const style = color ? { backgroundColor: `#${color.slice(2)}` } : {};
  return (
    <div className='bullet-wrapper-web-sdk'>
      <div className='bullet-web-sdk' style={style}>
        {title}
      </div>
      <p>{text}</p>
    </div>
  );
};

Bullet.propTypes = themePropTypes.bullet;

export default Bullet;
